import RenderComponent from '@/modules/DynamicRenderPage';
import { ROLES } from 'globalconfig/constants/keys';
import { hasRestrictedRole, loadPageConfig, loadStyle } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { basicRequest, sortColumnMapping } from './config';
import ParentStyled from './style';

let Styled = loadStyle(ParentStyled, 'pages/web/WorkOrders');
let timer;
const config = loadPageConfig();
const Title = lazy(() => import(`globalcomponents/Title`));
const Content = lazy(() => import(`@/${config.workOrders[1].name}`));
const TopActions = config.userList[0].children && lazy(() => import(`${config.userList[0].children.name}`));

const isSpireonNew = window.$environment.CURRENT_LAYOUT === 'SpireonNew';

const WorkOrders = (parentProps) => {
  const { fetchWorkOrders, history, i18n, theme, getFilters, workOrders } = parentProps;

  const [request, setRequest] = useState({
    ...basicRequest,
  });
  const commonParentProps = { history, i18n, Styled, theme };
  const [pagination, setPagination] = useState(false);
  const [filter, setFilter] = useState('OPEN');

  const changeRequest = (fields) => {
    if (fields?.sortCol) {
      const type = fields.sortCol;
      fields.sortCol = sortColumnMapping[type] ? sortColumnMapping[type] : fields.sortCol;
    }
    setRequest({ ...basicRequest, ...fields });
  };

  useEffect(() => {
    if (filter != request.state) setRequest({ ...request, state: filter });
  }, [filter]);

  useEffect(() => {
    fetchWorkOrders({
      apiId: 'fetchWorkOrders',
      data: request,
    });
  }, [request]);

  const filterSuccess = (data) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      setRequest({
        ...request,
        displayLength: basicRequest?.displayLength,
        displayStart: basicRequest?.displayStart,
        search: data,
      });
    }, 500);
  };

  const searchConfig = {
    setPagination,
    searchPlaceholder: i18n.t('workOrders.search'),
    fromData: false,
    filterSuccess,
    data: workOrders?.list,
    query: ['work_order_id', 'unitId', 'driverName', 'mechanicName'],
    isSpireonNew,
  };
  const viewOnly = hasRestrictedRole([ROLES.VIEW_ONLY_FM]);

  useEffect(() => {
    getFilters({ apiId: 'fetchFilters' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <RenderComponent
        {...config.workOrders[0]}
        parentProps={{
          ...parentProps,
          pagination,
          setPagination,
          filterSuccess,
        }}
        commonParentProps={commonParentProps}
        component={Title}
        childComponent={TopActions}
        searchConfig={isSpireonNew ? searchConfig : null}
      />
      <RenderComponent
        {...config.workOrders[1]}
        parentProps={{
          ...parentProps,
          pagination,
          setPagination,
          viewOnly,
          request,
          changeRequest,
          filter,
          setFilter,
          filterSuccess,
        }}
        commonParentProps={commonParentProps}
        component={Content}
      />
    </>
  );
};

const mapState = (state) => {
  return {
    workOrders: state.workOrders,
    filters: state.filters,
  };
};
const mapDispatch = (dispatch) => {
  return {
    fetchWorkOrders: (data) => dispatch.workOrders.fetchPaginateData(data),
    getFilters: (data) => dispatch.filters.fetchData(data),
  };
};

export default connect(mapState, mapDispatch)(WorkOrders);
WorkOrders.propTypes = {
  history: PropTypes.object.isRequired,
  fetchWorkOrders: PropTypes.func.isRequired,
  workOrders: PropTypes.array.isRequired,
};
